import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getWorkspaceProjects, createWorkspaceProject } from '../api'

export function useProjects(workspaceId) {
  const queryClient = useQueryClient()

  const isValidWorkspace = Boolean(workspaceId && typeof workspaceId === 'string' && /^[a-f\d]{24}$/i.test(workspaceId))
  const { data, isLoading, error } = useQuery({
    queryKey: ['projects', workspaceId],
    queryFn: () => getWorkspaceProjects(workspaceId),
    enabled: isValidWorkspace,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      const status = error?.status || error?.response?.status
      if (status && status >= 400 && status < 500) return false
      return failureCount < 2
    },
  })

  const createMutation = useMutation({
    mutationFn: ({ workspaceId, name }) => createWorkspaceProject({ workspaceId, name }),
    onSuccess: (resp) => {
      const created = resp?.data || resp
      queryClient.setQueryData(['projects', workspaceId], (old) => {
        const prev = old?.data || old || []
        return { data: [...prev, created] }
      })
    },
  })

  return {
    projects: data?.data || [],
    loading: isLoading,
    error: error?.message || null,
    createProject: (_workspaceId, name) => createMutation.mutateAsync({ workspaceId: _workspaceId, name }),
    refetchProjects: () => queryClient.invalidateQueries({ queryKey: ['projects', workspaceId] }),
  }
}
